import script from "./SignUpComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUpComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SignUpComponent.vue?vue&type=style&index=0&id=2bbef452&lang=css"

const __exports__ = script;

export default __exports__